import useStyles from "./styles";
import GreenLogo from "../assests/whitelogo.svg";
import MobileGoogle from "../assests/mobilegoogle.svg";
import MobileApple from "../assests/mobileapple.svg";
import Button from "../component/Button";
import { Icon } from "@iconify/react";
// import Slot from "../assests/slot.png";
import { useRef, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const FooterRef = useRef(null);
  const currentYear = new Date().getFullYear();

  const handleRegister = () => {
    const signupPath = "auth/register";
    const signupUrl = `${process.env.REACT_APP_DOMAIN}/${signupPath}`;
    window.open(signupUrl, "_blank", "noopener,noreferrer");
  };

  const handleLearnMore = () => {
    navigate("/about-us");
  };

  // Check if navigated here with a scroll trigger
  useEffect(() => {
    if (location.hash === "#footercont" && FooterRef.current) {
      FooterRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <div className={classes.maincont}>
      <div className={classes.featurecont}>
        <div className={classes.contmargin}>
          <div ref={FooterRef} className={classes.footercont}>
            <div className={classes.firstcont}>
              <img src={GreenLogo} alt="" />
              <h4>
                SLOT - Smart Savings, Stronger Connections.
              </h4>
              {/* <p>Shopfinance</p> */}
              <div className={classes.itembtn}>
                <a 
                  href="https://play.google.com/store/apps/details?id=com.slotmobile&pcampaignid=web_share" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Download on Google Play"
                >
                  <img src={MobileGoogle} alt="Google Play" />
                </a>
                <img src={MobileApple} alt="" />
              </div>
            </div>
            <div className={classes.itembtnright}>
              <Button
                variant="primary"
                color="btnfontprimary"
                buttonSize="buttonfluid"
                buttonName="Get Started"
                onClick={handleRegister}
              />
              <Button
                variant="whiteoutline"
                color="btnwhite"
                buttonSize="buttonfluid"
                buttonName="Learn More"
                onClick={handleLearnMore}
              />
            </div>
          </div>
          <hr />
          <div className={classes.footerflex}>
            <div className={classes.footerYear}>
              <Icon icon="mdi:copyright" width="16" height="16" />
               SLOT Finance | {currentYear}
            </div>
            <div className={classes.terms}>
              <p>
                <Link to="/terms">
                  Terms of Service
                </Link>
              </p>
              <p>
                <Link to="/privacy">
                  Privacy Policy
                </Link>
              </p>
              {/* <p>Cookies</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
